<template>
  <!-- Mostra só as páginas definidas no router -->
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* Reset básico */
html, body, #app {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
  background: linear-gradient(45deg, #35080a, #151b28);
  min-height: 100vh;
}
</style>
